import React, { useState } from "react";
import { useSelector, useDispatch } from 'react-redux'


/*
 * https://date-fns.org/v4.1.0/docs/addDays
 * https://www.npmjs.com/package/react-datepicker
 * https://reactdatepicker.com/#example-locale-without-global-variables
 */
import DatePicker from "react-datepicker";
import { registerLocale, setDefaultLocale } from  "react-datepicker";
import subDays from "date-fns/subDays"
import format from 'date-fns/format'
import { de } from 'date-fns/locale/de';

// SemanticUI ccomponents
import { Form, FormGroup, FormInput, Button, Icon, Table, FormCheckbox } from 'semantic-ui-react';

// Components
import { setContractData } from "./contractSlice";
import { setContractOptions } from "./contractSlice";
import { doContractAction } from "./contractSlice";

// Styles
import "react-datepicker/dist/react-datepicker.css";
import './contract.css';


registerLocale('de', de);
setDefaultLocale('de');



/**
 * 
 * @param {bool} editMode 
 * @returns 
 */
const Max2ContractSeasonRoomsSeasons = ({ editMode }) => {
  // local State
  const [seasonsStart, setSeasonsStart] = useState(0);

  // global State
  const dispatch = useDispatch();
  const Contract = useSelector((state) => state.contract.data.Contract);
  const Options = useSelector((state) => state.contract.data.Options);
  const seasonsDisplayMax = useSelector((state) => state.contract.maxSeasonsVisible);
  const dataSeasons = Contract.Seasons;

  // Edit mode?
  const readOnly = editMode ? false : true;

  // check if rooms defined
  if (typeof Contract?.Rooms === 'undefined' || !Contract?.Rooms.length) {
    return (
      <p>Keine Zimmer definiert</p>
    )
  }

  // Filter visible seasons
  const moreSeasons = Object.keys(dataSeasons).length > seasonsDisplayMax ? true : false;
  let i=-1;
  let seasonsToDisplay = [];
  let maxSeasonRows = 0;
  for (const seasonKey in dataSeasons) {
    i++;
    if (Object.prototype.hasOwnProperty.call(dataSeasons, seasonKey)) {
      if (i >= seasonsStart && i < (seasonsStart + seasonsDisplayMax)) {
        seasonsToDisplay.push(seasonKey);
      }
      if (dataSeasons[seasonKey].length > maxSeasonRows) {
        maxSeasonRows = dataSeasons[seasonKey].length;
      }
    }
  }

  // 
  const nextSeasonClick = () => {
    if ((seasonsStart + seasonsDisplayMax) < (Object.keys(dataSeasons).length)) {
      setSeasonsStart(seasonsStart + 1)
    }
  };

  //
  const prevSeasonClick = () => {
    if (seasonsStart > 0) {
      setSeasonsStart(seasonsStart - 1)
    }
  };

  //
  const wdOn = {padding: "2px", cursor: 'pointer'}
  const wdOff = {padding: "2px", cursor: 'pointer', color: "#ddd"}

  let seasonRows = [];
  for (let i=0; i<maxSeasonRows; i++) {
    seasonRows.push(
      <Table.Body key={i}>
        <Table.Row>
          <Table.Cell rowSpan={2} textAlign="center"></Table.Cell>
          {seasonsToDisplay.map((seasonKey, seasonIndex) => (
            <Table.Cell key={seasonKey} className={seasonIndex % 2 ? 'room even' : 'room odd'} textAlign="right">
              <Form style={{marginLeft: "-15px"}}>
                <DatePicker
                  showWeekNumbers
                  selectsStart
                  selected    = {dataSeasons[seasonKey][i]?.Start}
                  startDate   = {dataSeasons[seasonKey][i]?.Start}
                  endDate     = {dataSeasons[seasonKey][i]?.End}
                  dateFormat  = "dd.MM.yyyy"
                  placeholder = 'TT.MM.JJJJ'
                  onChange    = {(date) => dispatch(setContractData({target: 'Season.Start', season: seasonKey, row: i,  value: format(date, "yyyy-MM-dd")}))}
                  customInput = {<FormInput inline className="small" icon='calendar alternate' iconPosition='left' label="von" placeholder='TT.MM.JJJJ' style={{width: "130px"}} />}
                  excludeDateIntervals = {[
                    { start: new Date("1970-01-01"), end: subDays(new Date(Contract.Period.Start), 1) },
                    { start: new Date(Contract.Period.End), end: new Date("9999-12-31") },
                  ]}
                /><br />
                <DatePicker
                  showWeekNumbers
                  selectsEnd
                  selected    = {dataSeasons[seasonKey][i]?.End}
                  startDate   = {dataSeasons[seasonKey][i]?.Start}
                  endDate     = {dataSeasons[seasonKey][i]?.End}
                  minDate     = {dataSeasons[seasonKey][i]?.Start}
                  dateFormat  = "dd.MM.yyyy"
                  placeholder = 'TT.MM.JJJJ'
                  onChange    = {(date) => dispatch(setContractData({target: 'Season.End', season: seasonKey, row: i,  value: format(date, "yyyy-MM-dd")}))}
                  customInput = {<FormInput inline className="small" icon='calendar alternate' iconPosition='left' label="bis" placeholder='TT.MM.JJJJ' style={{width: "130px"}} />}
                  excludeDateIntervals = {[
                    { start: new Date("1970-01-01"), end: subDays(new Date(Contract.Period.Start), 1) },
                    { start: new Date(Contract.Period.End), end: new Date("9999-12-31") },
                    { start: subDays(new Date(Contract.Period.Start), 1), end: subDays(dataSeasons[seasonKey][i]?.End, 1) },
                  ]}
                />
              </Form>
            </Table.Cell>
          ))}
          <Table.Cell rowSpan={Options.isSeasonWeekdays ? 2 : 1} textAlign="center">
              <>
              {i === (maxSeasonRows - 1) && (
                <>
                <Button basic icon circular size="tiny" title="Saisonzeile hinzufügen" onClick={()=>dispatch(doContractAction({ target: 'Season.addSeasonRow' }))}><Icon name="add" /></Button>
                {i > 0 && (
                  <>
                  <br />
                  <Button basic icon circular size="tiny" title="Saisonzeile löschen" onClick={()=>dispatch(doContractAction({ target: 'Season.delSeasonRow' }))}><Icon name="minus" /></Button>
                  </>
                )}
                </>
              )}
              </>
          </Table.Cell>
        </Table.Row>
        {Options.isSeasonWeekdays && (
          <Table.Row>
            {seasonsToDisplay.map((seasonKey, seasonIndex) => (
              <Table.Cell key={seasonKey} className={seasonIndex % 2 ? 'room even' : 'room odd'} textAlign="center">
                <span style={dataSeasons[seasonKey][i]?.Weekdays?.Mon ? wdOn : wdOff} onClick={() => { dispatch(setContractData({target: 'Season.Weekday', season: seasonKey, row: i, weekday: 'Mon', value: !dataSeasons[seasonKey][i]?.Weekdays.Mon}))}}>Mo</span>
                <span style={dataSeasons[seasonKey][i]?.Weekdays?.Tue ? wdOn : wdOff} onClick={() => { dispatch(setContractData({target: 'Season.Weekday', season: seasonKey, row: i, weekday: 'Tue', value: !dataSeasons[seasonKey][i]?.Weekdays.Tue}))}}>Di</span>
                <span style={dataSeasons[seasonKey][i]?.Weekdays?.Wed ? wdOn : wdOff} onClick={() => { dispatch(setContractData({target: 'Season.Weekday', season: seasonKey, row: i, weekday: 'Wed', value: !dataSeasons[seasonKey][i]?.Weekdays.Wed}))}}>Mi</span>
                <span style={dataSeasons[seasonKey][i]?.Weekdays?.Thu ? wdOn : wdOff} onClick={() => { dispatch(setContractData({target: 'Season.Weekday', season: seasonKey, row: i, weekday: 'Thu', value: !dataSeasons[seasonKey][i]?.Weekdays.Thu}))}}>Do</span>
                <span style={dataSeasons[seasonKey][i]?.Weekdays?.Fri ? wdOn : wdOff} onClick={() => { dispatch(setContractData({target: 'Season.Weekday', season: seasonKey, row: i, weekday: 'Fri', value: !dataSeasons[seasonKey][i]?.Weekdays.Fri}))}}>Fr</span>
                <span style={dataSeasons[seasonKey][i]?.Weekdays?.Sat ? wdOn : wdOff} onClick={() => { dispatch(setContractData({target: 'Season.Weekday', season: seasonKey, row: i, weekday: 'Sat', value: !dataSeasons[seasonKey][i]?.Weekdays.Sat}))}}>Sa</span>
                <span style={dataSeasons[seasonKey][i]?.Weekdays?.Sun ? wdOn : wdOff} onClick={() => { dispatch(setContractData({target: 'Season.Weekday', season: seasonKey, row: i, weekday: 'Sun', value: !dataSeasons[seasonKey][i]?.Weekdays.Sun}))}}>So</span>
              </Table.Cell>
            ))}
          </Table.Row>
        )}
      </Table.Body>
    );
  }


  //
  const headerSeasons = seasonsToDisplay.map((seasonKey, seasonIndex) => {
    const headerSeasonsPeriods = dataSeasons[seasonKey].map((period, index) => {
      if (!period.Start || !period.End) {
        return <></>
      }
      const fdateStart = format(new Date(period.Start), 'dd.MM.')
      const fdateEnd = format(new Date(period.End), 'dd.MM.')
      return (
        <span key={index}>{fdateStart} - {fdateEnd}<br /></span>
      )
    });

    return (
      <Table.HeaderCell key={seasonKey} className={seasonIndex % 2 ? 'season even' : 'season odd'} textAlign="center">
        {headerSeasonsPeriods}
      </Table.HeaderCell>
    )
  });




  if (readOnly) {
    return (
      <Table celled structured singleLine basic='very'>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell textAlign="center">
              {moreSeasons && seasonsStart > 0 && (
                <Icon link name='chevron left' onClick={()=>prevSeasonClick()} />
              )}
            </Table.HeaderCell>
            {seasonsToDisplay.map((seasonKey, seasonIndex) => (
              <Table.HeaderCell key={seasonKey} className={seasonIndex % 2 ? 'season even' : 'season odd'} textAlign="center">Saison {seasonKey}</Table.HeaderCell>
            ))}
            <Table.HeaderCell textAlign="center">
              {moreSeasons && (seasonsStart + seasonsDisplayMax) < Object.keys(dataSeasons).length && (
                <Icon link name='chevron right' onClick={()=>nextSeasonClick()} />
              )}
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        {[...Array(maxSeasonRows)].map((x, i) =>
          <>
          <Table.Body key={i}>
            <Table.Row>
              <Table.Cell textAlign="center"></Table.Cell>
              {seasonsToDisplay.map((seasonKey, seasonIndex) => (
                <Table.Cell key={seasonKey} className={seasonIndex % 2 ? 'room even' : 'room odd'} textAlign="center">
                  <span>{dataSeasons[seasonKey][i]?.Start ? format(dataSeasons[seasonKey][i]?.Start, "dd.MM.yyyy") : ''} - {dataSeasons[seasonKey][i]?.End ? format(dataSeasons[seasonKey][i]?.End, "dd.MM.yyyy") : ''}</span>
                  {Options.isSeasonWeekdays && (
                    <>
                    <br />
                    {dataSeasons[seasonKey][i]?.Weekdays?.Mon && dataSeasons[seasonKey][i]?.Weekdays?.Tue && dataSeasons[seasonKey][i]?.Weekdays?.Wed && dataSeasons[seasonKey][i]?.Weekdays?.Thu && dataSeasons[seasonKey][i]?.Weekdays?.Fri && dataSeasons[seasonKey][i]?.Weekdays?.Sat && dataSeasons[seasonKey][i]?.Weekdays?.Sun && (
                      <>tgl</>
                    )}
                    {(!dataSeasons[seasonKey][i]?.Weekdays?.Mon || !dataSeasons[seasonKey][i]?.Weekdays?.Tue || !dataSeasons[seasonKey][i]?.Weekdays?.Wed || !dataSeasons[seasonKey][i]?.Weekdays?.Thu || !dataSeasons[seasonKey][i]?.Weekdays?.Fri || !dataSeasons[seasonKey][i]?.Weekdays?.Sat || !dataSeasons[seasonKey][i]?.Weekdays?.Sun) && (
                        <>
                        {dataSeasons[seasonKey][i]?.Weekdays?.Mon && (<span style={wdOn}>Mo</span>)}
                        {dataSeasons[seasonKey][i]?.Weekdays?.Tue && (<span style={wdOn}>Di</span>)}
                        {dataSeasons[seasonKey][i]?.Weekdays?.Wed && (<span style={wdOn}>Mi</span>)}
                        {dataSeasons[seasonKey][i]?.Weekdays?.Thu && (<span style={wdOn}>Do</span>)}
                        {dataSeasons[seasonKey][i]?.Weekdays?.Fri && (<span style={wdOn}>Fr</span>)}
                        {dataSeasons[seasonKey][i]?.Weekdays?.Sat && (<span style={wdOn}>Sa</span>)}
                        {dataSeasons[seasonKey][i]?.Weekdays?.Sun && (<span style={wdOn}>So</span>)}
                        </>
                    )}
                    </>
                  )}
                </Table.Cell>
              ))}
              <Table.Cell rowSpan={Options.isSeasonWeekdays ? 2 : 1} textAlign="center"></Table.Cell>
            </Table.Row>
          </Table.Body>
          </>
        )}
      </Table>
    )
  }
  






  return (
    <>
    <Table celled structured singleLine basic='very'>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell rowSpan="2" textAlign="center">
            {moreSeasons && seasonsStart > 0 && (
              <Icon link name='chevron left' onClick={()=>prevSeasonClick()} />
            )}
          </Table.HeaderCell>
          {seasonsToDisplay.map((seasonKey, seasonIndex) => (
            <Table.HeaderCell key={seasonKey} className={seasonIndex % 2 ? 'season even' : 'season odd'} textAlign="center">Saison {seasonKey}</Table.HeaderCell>
          ))}
          <Table.HeaderCell rowSpan="2" textAlign="center">
            {moreSeasons && (seasonsStart + seasonsDisplayMax) < Object.keys(dataSeasons).length && (
              <Icon link name='chevron right' onClick={()=>nextSeasonClick()} />
            )}
          </Table.HeaderCell>
        </Table.Row>
        <Table.Row>
          {headerSeasons}
        </Table.Row>
      </Table.Header>
      {seasonRows}
      <Table.Footer>
        <Table.Row>
          <Table.Cell rowSpan="2" textAlign="center"></Table.Cell>
          {seasonsToDisplay.map((seasonKey, seasonIndex) => (
            <Table.Cell key={seasonKey} className={seasonIndex % 2 ? 'season even' : 'season odd'} textAlign="center">
              {seasonIndex === (seasonsToDisplay.length - 1) && (
                <>
                {seasonIndex > 0 && (
                  <Button basic icon circular size="tiny" title="Saison löschen" onClick={()=>dispatch(doContractAction({ target: 'Season.delSeason' }))}><Icon name="minus" /></Button>
                )}
                <Button basic icon circular size="tiny" title="Saison hinzufügen" onClick={()=>dispatch(doContractAction({ target: 'Season.addSeason' }))}><Icon name="add" /></Button>
                </>
              )}
            </Table.Cell>
          ))}
          <Table.Cell rowSpan="2" textAlign="center"></Table.Cell>
        </Table.Row>
      </Table.Footer>
    </Table>
    <Form>
      <FormGroup>
        <FormCheckbox toggle label="Wochentage-Logik nutzen" checked={Options.isSeasonWeekdays ? true : false} onClick={() => dispatch(setContractOptions({target: 'isSeasonWeekdays', value: !Options.isSeasonWeekdays}))} />
      </FormGroup>
    </Form>
    </>
  )
}


export default Max2ContractSeasonRoomsSeasons;